import { useEffect, useRef, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { getAllPrograms } from "../../../../store/slices/programsSlice";
import { useSelector } from "react-redux";
import ServiceForm from "./serviceForm";

const CreateServiceModal = ({ isOpen, toggle, pagination }) => {
  const serviceFormRef = useRef();
  const dispatch = useDispatch();
  const {
    register,
    formState: { errors },
  } = useForm({ defaultValues: { name: "", description: "" } });
  const [formFieldsValidation, setFormFieldsValidation] = useState({
    role_value: {
      ...register("name", { required: "This field is required" }),
    },
    description: {
      ...register("description", { required: "This field is required" }),
    },
    program_id: {
      ...register("program_id", { required: "This field is required" }),
    },
  });

  useEffect(() => {
    fetchAllPrograms();
  }, []);

  const fetchAllPrograms = () => {
    dispatch(getAllPrograms());
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl">
      <ModalHeader>Create Service</ModalHeader>
      <ModalBody>
        <ServiceForm
          ref={serviceFormRef}
          toggle={toggle}
          formType={"create"}
          pagination={pagination}
        />
      </ModalBody>
      <ModalFooter className="d-flex customModalFooter">
        <button
          className="btn bg-primary"
          onClick={() => serviceFormRef.current?.handleSubmit?.()}
        >
          Create
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default CreateServiceModal;
